import { connect } from 'react-redux';
import Listings from './Listings';
import {
  pricesBedsFilterSelector,
  pricesFinalTransactionsFilterSelector,
  pricesTabSelector,
  pricesYearFilterSelector,
} from 'store/state/insightsContext/selectors';
import { RootAction, State } from 'store/state';
import { setPricesTab } from 'store/state/insightsContext/actions';
import { pricesListingsSelector, pricesStateSelector, PricesTabType } from 'store/state/selectors/insights/prices';
import { isConnectedUserSelector } from 'store/state/domainData/selectors';
import { bulletinIdSelector } from '../selectors';
import { Dispatch } from 'redux';
import { AuthenticationModalPayload } from 'components/authentication/types';
import { AuthModalSource } from 'store/state/app';
import { setAuthModal } from 'store/state/app/actions';

const mapStateToProps = (state: State) => ({
  activeTab: pricesTabSelector(state),
  section: pricesListingsSelector(state),
  pricesState: pricesStateSelector(state),
  unitPageBulletinId: bulletinIdSelector(state),
  yearFilter: pricesYearFilterSelector(state),
  bedsFilter: pricesBedsFilterSelector(state),
  showOnlyFinalTransactionsFilter: pricesFinalTransactionsFilterSelector(state),
  isConnectedUser: isConnectedUserSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  setActiveTab: (tabId: PricesTabType) => dispatch(setPricesTab(tabId)),
  onSetAuthModal: (payload: AuthenticationModalPayload, meta: { isUserInitiated?: boolean, source?: AuthModalSource }) => dispatch(setAuthModal(payload, meta)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Listings);
